'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _app = require('./app.component');

var _app2 = _interopRequireDefault(_app);

var _admin = require('./admin/admin.module');

var _admin2 = _interopRequireDefault(_admin);

var _account = require('./account/account.module');

var _account2 = _interopRequireDefault(_account);

var _adverseEvent = require('./adverse-event/adverse-event.module');

var _adverseEvent2 = _interopRequireDefault(_adverseEvent);

var _adverseEvents = require('./adverse-events/adverse-events.module');

var _adverseEvents2 = _interopRequireDefault(_adverseEvents);

var _common = require('./common/common.module');

var _common2 = _interopRequireDefault(_common);

var _dashboard = require('./dashboard/dashboard.module');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _product = require('./product/product.module');

var _product2 = _interopRequireDefault(_product);

var _treatProduct = require('./product/treat-product.module');

var _treatProduct2 = _interopRequireDefault(_treatProduct);

var _products = require('./products/products.module');

var _products2 = _interopRequireDefault(_products);

var _reports = require('./reports/reports.module');

var _reports2 = _interopRequireDefault(_reports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app', [_angularUiRouter2.default, _admin2.default, _account2.default, _adverseEvent2.default, _adverseEvents2.default, _common2.default, _dashboard2.default, _product2.default, _treatProduct2.default, _products2.default, _reports2.default]).component('app', _app2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('app', {
    redirectTo: 'dashboard',
    url: '/app',
    // data: {
    //   permissions: {
    //     except: ['ANONYMOUS'],
    //     redirectTo: 'login'
    //   }
    // },
    resolve: {
      flex: function flex() {
        return '100';
      },
      layout: function layout() {
        return 'column';
      },
      currentUser: function currentUser(SessionService) {
        return SessionService.user;
      }
    },
    component: 'app'
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/app.module.js